import { render, staticRenderFns } from "./PopularSearch.vue?vue&type=template&id=62617e7c&scoped=true&"
import script from "./PopularSearch.vue?vue&type=script&lang=js&"
export * from "./PopularSearch.vue?vue&type=script&lang=js&"
import style0 from "./PopularSearch.vue?vue&type=style&index=0&id=62617e7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62617e7c",
  null
  
)

export default component.exports